import injectSheet from 'react-jss'
import SearchResults from './SearchResults'
import styles from './SearchResults.styles'

export default injectSheet(styles)(SearchResults)
